import React from "react";
import { Link } from "react-router-dom";

const TheHomeDepot = () => {
  return (
    <div className="the-home-depot-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeIn" data-wow-delay="0.5s">
            <h1>
              <img
                src="/assets/images/logos/logo-home-depot-orange.svg"
                alt="Home Depot"
                style={{ height: "80px", width: "80px" }}
              />
            </h1>
            <h2>Home Depot's Non-Merch Logistics System!</h2>
            <div className="breadcrumb">
              <span>
                Portfolio / <strong>The Home Depot</strong>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="whatwedo-section">
        <div className="container">
          <div className="row">
            <div className="col col-4">
              <h2>What We Did</h2>
              <ul className="list">
                <li>Product Design</li>
                <li>Web Development</li>
                <li>Backend Development</li>
                <li>Security</li>
              </ul>
            </div>
            <div className="col col-8">
              <h2>Overview</h2>
              <p>
                The Home Depot, a global leader in home improvement retail, engaged us to design and develop a
                platform to manage their logistics operations. The primary objective of the platform was to
                evaluate the most cost-effective and time-efficient options for transporting logistics through
                third-party vendors. Furthermore, it needed to be able to track shipment status and live
                location, as well as communicate EDI messages to vendors with detailed shipment information.
              </p>
              <p>
                To streamline the invoicing process, the platform was designed to create invoices and send them
                to vendors upon shipment. The platform had to be reliable, fast, and scalable to handle the high
                volume of logistics operations of The Home Depot. The team collaborated closely with The Home
                Depot to ensure the platform met all their requirements and delivered an efficient and effective
                logistics management solution.
              </p>
            </div>
          </div>
          <div className="portfolio-carousel">
            <div className="slide-content">
              <img
                src="/assets/images/background/home-depot/Home-Depot.jpg"
                alt="Home Depot"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="challenges-section">
        <div className="container">
          <div className="challenges">
            <div className="col col-6">
              <div className="img-card">
                <img
                  src="/assets/images/background/home-depot/Home-depot-tab1.jpg"
                  alt="home-depot"
                />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Challenges</h3>
                <div className="scroll">
                  <p>
                    The Home Depot project came with several challenges, including security concerns that
                    arose from previous development work done by another team. To address these concerns,
                    the team decided to switch from PHP to Java Spring Boot, which offered enhanced security
                    measures.
                  </p>
                  <p>
                    Creating a secure platform was also a top priority for the client, requiring advanced
                    encryption algorithms to be used in storing and transmitting sensitive information.
                  </p>
                  <p>
                    The project also faced functional challenges, including issues with data transfer methods
                    and the need to ensure that the system could communicate and exchange data seamlessly
                    with all third-party logistics vendors. The team had to align the system to ensure
                    accurate evaluation of shipment cost and time with third-party vendors.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-6 flex-reverse">
              <div className="img-card">
                <img
                  src="/assets/images/background/home-depot/Home-depot-tab.jpg"
                  alt="home-depot-1"
                />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Solutions</h3>
                <div className="scroll">
                  <p>
                    Implemented Java Spring Boot for backend to ensure better security and scalability for
                    the platform.
                  </p>
                  <p>
                    Implemented advanced security measures such as role-based access control and encryption
                    for data at rest and in transit to ensure a highly secure platform.
                  </p>
                  <p>
                    Integrated the platform with third-party logistics providers through API integration to
                    enable real-time tracking of shipments and automatic updates to the platform.
                  </p>
                  <p>
                    Designed and developed a robust system that can communicate and exchange data with all
                    the third-party logistics vendors.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section">
        <div className="container">
          <div className="download-app">
            <h2>Test Drive our Results</h2>
            <p>Experience the impact of our work firsthand</p>
            <div className="app-link">
              <a
                href="https://prod.thdnmlogistics.com/logistic/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/images/logos/logo-website.png" alt="logo" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-3" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TheHomeDepot;
